import NavbarComp from '../components/navbarComp';

const NavigationBar = () => {
    return <NavbarComp />;
};

export default NavigationBar;
